import React from 'react';

import { TAttachmentDTOCamelCased, TAttachmentOnClient } from '@entities/attachment/model/types';
import { AttachmentsList } from '@entities/attachment/ui';
import { DnD } from '@shared/ui';

import cls from './JournalEventsFileUploader.module.css';
import { useJournalEventsFilesUploader } from './lib/hooks';
import { IJournalEventsFilesUploaderBase } from './model/types';

export const JournalEventsFilesUploader = ({
    attachments,
    setAttachments,
    isDisabled,
}: IJournalEventsFilesUploaderBase) => {
    const { fileInputRef, onUploadHandler, t, onClickInputRef, onDeleteAttachment } =
        useJournalEventsFilesUploader({
            attachments,
            setAttachments,
        });

    return (
        <DnD<TAttachmentOnClient | TAttachmentDTOCamelCased>
            attachmentsData={attachments}
            onUploadHandler={onUploadHandler}
            isDisabled={isDisabled}
            fileInputRef={fileInputRef}
            containerClassName={cls.UploadContainer}
            renderAttachmentsList={() => (
                <AttachmentsList
                    t={t}
                    attachments={attachments}
                    onClickFileInput={onClickInputRef}
                    onDeleteAttachment={onDeleteAttachment}
                    isDisabled={isDisabled}
                />
            )}
        />
    );
};
